import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageHeader } from 'antd';

import { RegionsList } from '@containers/regions';
import RegionsActions from '@redux/RegionsRedux';

import './Regions.less';

function RegionsPage(props) {
  const { fetchRegions } = props;
  useEffect(() => {
    fetchRegions();
  }, []);
  return (
    <div className="users main-page">
      <PageHeader
        title="Regions"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
      />
      <RegionsList />
    </div>
  );
}

RegionsPage.propTypes = {
  fetchRegions: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  fetchRegions: () => dispatch(RegionsActions.fetchRegions())
});

export default connect(
  null,
  mapDispatchToProps
)(RegionsPage);
